// import { useState, useEffect, useCallback } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import api from "@/components/customAxios/Axios";

import useBreadCrumb from "@/context/BreadCrumbContext";
import useUserName from "@/context/UserNameContext";
import { Link } from "react-router-dom";
import SidebarMenu from "./SideBarMenu";
import { useEffect, useRef, useState } from "react";
import logo from "@/assets/talentick.ai.webp"
const Header = () => {
	const { breadCrumb } = useBreadCrumb();
	const { userName } = useUserName();
	const [isSidebarOpen, setSidebarOpen] = useState(false);

	const sidebarRef = useRef<HTMLDivElement>(null);

	const toggleSidebar = () => setSidebarOpen((prev) => !prev);

	// Close sidebar on click outside
	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			if (
				sidebarRef.current &&
				!sidebarRef.current.contains(event.target as Node)
			) {
				setSidebarOpen(false);
			}
		};

		if (isSidebarOpen) {
			document.addEventListener("mousedown", handleClickOutside);
		} else {
			document.removeEventListener("mousedown", handleClickOutside);
		}

		// Clean up
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [isSidebarOpen]);

	return (
		<>
			<header className="flex justify-between items-center   bg-white  h-[70px]  z-40 lg:z-0 boder px-3 border lg:w-full w-screen lg:relative sticky top-0">



				<div className="space-x-3 text-gray-400 text-lg font-normal px-1.5 hidden lg:inline">
					<Link to={breadCrumb.mainLabel.link} className="">
						{breadCrumb.mainLabel.label}
					</Link>{" "}
					{breadCrumb.currentLabel && (
						<>
							<span>/</span>
							<span className="text-gray-700">{breadCrumb.currentLabel}</span>
						</>
					)}
				</div>
				<div className="flex justify-center items-center py-3 sm:py-4 lg:mt-3">
					<img
						src={logo}
						className="w-36 mr-8 cursor-pointer lg:hidden"
						alt="Bluetick Logo"
					/>
					{/* <img
						src={logo}
						className="w-10 cursor-pointer md:hidden"
						alt="Bluetick Logo"
					/> */}
				</div>
				<div className="flex items-center lg:px-3">
					{/* <button>
					<svg
						width="28"
						height="28"
						viewBox="0 0 28 28"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M20.25 19H7.75002C7.64063 18.9993 7.53333 18.97 7.43884 18.9149C7.34435 18.8597 7.26599 18.7808 7.21158 18.6859C7.15717 18.591 7.12862 18.4835 7.12878 18.3741C7.12895 18.2647 7.15783 18.1572 7.21252 18.0625C7.72737 17.1719 8.37502 14.9227 8.37502 12.125C8.37502 10.6332 8.96766 9.20242 10.0225 8.14752C11.0774 7.09263 12.5082 6.5 14 6.5C15.4919 6.5 16.9226 7.09263 17.9775 8.14752C19.0324 9.20242 19.625 10.6332 19.625 12.125C19.625 14.9234 20.2735 17.1719 20.7891 18.0625C20.8438 18.1574 20.8727 18.2649 20.8728 18.3745C20.8729 18.484 20.8442 18.5916 20.7896 18.6865C20.735 18.7815 20.6565 18.8604 20.5618 18.9154C20.467 18.9705 20.3595 18.9996 20.25 19Z"
							fill="black"
							fill-opacity="0.04"
						/>
						<path
							d="M21.3281 17.7453C20.8945 16.9984 20.2499 14.8852 20.2499 12.125C20.2499 10.4674 19.5915 8.87769 18.4194 7.70558C17.2473 6.53348 15.6576 5.875 13.9999 5.875C12.3423 5.875 10.7526 6.53348 9.58053 7.70558C8.40843 8.87769 7.74995 10.4674 7.74995 12.125C7.74995 14.8859 7.10464 16.9984 6.67104 17.7453C6.56032 17.9352 6.50162 18.1509 6.50086 18.3707C6.50011 18.5905 6.55733 18.8066 6.66674 18.9973C6.77616 19.1879 6.93392 19.3463 7.12409 19.4565C7.31427 19.5667 7.53015 19.6248 7.74995 19.625H10.9382C11.0824 20.3306 11.4659 20.9647 12.0238 21.4201C12.5817 21.8756 13.2798 22.1243 13.9999 22.1243C14.7201 22.1243 15.4182 21.8756 15.9761 21.4201C16.534 20.9647 16.9175 20.3306 17.0617 19.625H20.2499C20.4697 19.6247 20.6855 19.5665 20.8755 19.4562C21.0656 19.346 21.2232 19.1875 21.3326 18.9969C21.4419 18.8063 21.499 18.5903 21.4983 18.3705C21.4975 18.1508 21.4388 17.9351 21.3281 17.7453ZM13.9999 20.875C13.6123 20.8749 13.2342 20.7546 12.9178 20.5308C12.6013 20.3069 12.362 19.9905 12.2328 19.625H15.7671C15.6379 19.9905 15.3986 20.3069 15.0821 20.5308C14.7657 20.7546 14.3876 20.8749 13.9999 20.875ZM7.74995 18.375C8.35151 17.3406 8.99995 14.9438 8.99995 12.125C8.99995 10.7989 9.52673 9.52715 10.4644 8.58947C11.4021 7.65178 12.6739 7.125 13.9999 7.125C15.326 7.125 16.5978 7.65178 17.5355 8.58947C18.4732 9.52715 18.9999 10.7989 18.9999 12.125C18.9999 14.9414 19.6468 17.3383 20.2499 18.375H7.74995Z"
							fill="black"
						/>
					</svg>
				</button> */}

					<div className="rounded-full border-1 overflow-hidden size-10 lg:mr-2 ">
						{" "}
						<img
							src="https://upload.wikimedia.org/wikipedia/commons/5/59/User-avatar.svg"
							alt="Profile"
							className="size-12 "
						/>
					</div>
					<div className="font-normal hidden lg:block">{userName}</div>
					<button onClick={toggleSidebar} className="lg:hidden p-2">
						<svg
							className="w-6 h-6"
							fill="none"
							stroke="currentColor"
							viewBox="0 0 24 24"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								strokeLinecap="round"
								strokeLinejoin="round"
								strokeWidth={2}
								d="M4 6h16M4 12h16M4 18h16"
							/>
						</svg>
					</button>
				</div>
			</header>
			{/* Backdrop */}
			{isSidebarOpen && (
				<div className="fixed inset-0 bg-black bg-opacity-25 z-40 lg:hidden" />
			)}

			{/* Sidebar with ref for outside click */}
			<div
				ref={sidebarRef}
				className={`fixed top-0 left-0 h-full w-64 bg-white z-50 transform transition-transform duration-300 ease-in-out lg:hidden ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"
					}`}
			>
				<SidebarMenu />
			</div>
		</>
	);
};

export default Header;
